import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import {
  APP_SETTINGS_GROUPS_FEED_SHOW_VENDOR_GROUPS_KEY,
  APP_SETTINGS_QUERY_KEY,
} from '@/config/appSettingsKeys'

/**
 * Global feature flag: show vendor groups (broadcaster and ad-creator groups) in the main
 * Groups feed and in join-group lists. When false, only community groups are shown.
 * Stored in app_settings; toggled in Admin → Feature flags.
 */
export function useGroupsFeedShowVendorGroupsFlag() {
  const { data: value, isLoading } = useQuery({
    queryKey: [...APP_SETTINGS_QUERY_KEY, APP_SETTINGS_GROUPS_FEED_SHOW_VENDOR_GROUPS_KEY],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('app_settings')
        .select('value')
        .eq('key', APP_SETTINGS_GROUPS_FEED_SHOW_VENDOR_GROUPS_KEY)
        .maybeSingle()
      if (error) return false
      return data?.value === 'true'
    },
    staleTime: 60_000,
  })
  return { showVendorGroupsInFeed: value ?? false, isLoading }
}
